'use client';

import { Checkbox, Grid, ListItemText, MenuItem, ThemeProvider } from '@mui/material';
import useWhatToPracticeSelector from './useWhatToPracticeSelector';
import styles from './WhatToPracticeSelector.module.scss';
import { green } from '@mui/material/colors';

import { useTranslation } from 'react-i18next';
import SelectComponent from '@/shared/SelectComponent';
import { practiceOptions, whiteTheme } from '@/types';

const WhatToPracticeSelector = () => {
  const { t } = useTranslation();

  const { selectedPractices, handlePracticeTypeSelectionChange } = useWhatToPracticeSelector();
  const selectOptions = Object.values(practiceOptions).map((practice) => (
    <MenuItem key={practice} value={practice}>
      <Checkbox
        sx={{
          color: green[800],
          '&.Mui-checked': {
            color: green[600],
          },
        }}
        checked={selectedPractices.indexOf(practice) > -1}
      />
      <ListItemText primary={t(practice)} />
    </MenuItem>
  ));

  return (
    <ThemeProvider theme={whiteTheme}>
      <Grid container>
        <Grid display='flex' justifyContent='center' alignItems='center' size={12}>
          <div className={styles.root}>
            <SelectComponent
              multiple
              labelId='select-multiple-checkbox-label'
              selectId='select-multiple-checkbox'
              selectOptions={selectOptions}
              selectedValue={selectedPractices}
              handleChange={handlePracticeTypeSelectionChange}
              selectLabel={t('what-to-practice.select-1.label-text')}
              renderValue={(selected) => (selected as string[]).map((k) => t(k)).join(', ')}
              formControlSx={{ m: 1, mt: 2, minWidth: 216 }}
            />
          </div>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default WhatToPracticeSelector;
